import '@babel/polyfill';
// Import Component hooks before component definitions
import { i18n } from '@/plugins/vue-i18n';
import vuetify from '@/plugins/vuetify';
import store from '@/store';
import Vue from 'vue';
import App from './App.vue';
import './component-hooks';
import './utils/loadGtm';
import './plugins/vee-validate';
import './plugins/vuetify';
import './plugins/clerk';
import router from './router';
import { readUserLocale } from './store/main/getters';

require('./styles/styles.scss');
require('./styles/layout.css');

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  beforeCreate() {
    store.watch(
      () => readUserLocale(store),
      (newLocale) => {
        i18n.locale = newLocale;
      }
    );
  },
  render: (h) => h(App),
}).$mount('#app');
